import React, { FC, KeyboardEvent } from 'react';
import styles from './ToggleSwitch.module.css';

export interface ToggleSwitchProps {
    id: string;
    checked: boolean;
    onChange: (checked: boolean) => void;
    name?: string;
    optionLabels?: [string, string];
    small?: boolean;
    disabled?: boolean;
}

export const ToggleSwitch: FC<ToggleSwitchProps> = ({
    id,
    checked,
    onChange,
    name,
    optionLabels = ['ON', 'OFF'],
    small = false,
    disabled = false,
}) => {
    const handleKeyPress = (e: KeyboardEvent<HTMLLabelElement>) => {
        if (e.key !== ' ' && e.key !== 'Enter') return;
        e.preventDefault();
        onChange(!checked);
    };

    return (
        <div className={`${styles['toggle-switch']} ${small ? styles['small-switch'] : ''}`}>
            <input
                type="checkbox"
                name={name}
                className={styles['toggle-switch-checkbox']}
                id={id}
                checked={checked}
                onChange={(e) => onChange(e.target.checked)}
                disabled={disabled}
            />
            {id && (
                <label
                    className={styles['toggle-switch-label']}
                    tabIndex={disabled ? -1 : 0}
                    onKeyDown={handleKeyPress}
                    htmlFor={id}
                    role="switch"
                    aria-checked={checked}
                    aria-disabled={disabled}>
                    <span
                        className={`${styles['toggle-switch-inner']} ${disabled ? styles['toggle-switch-disabled'] : ''}`}
                        data-yes={optionLabels[0]}
                        data-no={optionLabels[1]}
                    />
                    <span className={`${styles['toggle-switch-switch']} ${disabled ? styles['toggle-switch-disabled'] : ''}`} />
                </label>
            )}
        </div>
    );
};
